export default __webpack_public_path__ + "static/media/Cuisse of the Sanguine Disciple (nm).929e5e08.jpg";